export enum ContentImageType {
  CONTENT_IMAGE_FROM_USER_FILE = 'CONTENT_IMAGE_FROM_USER_FILE',
  CONTENT_IMAGE_FROM_URL = 'CONTENT_IMAGE_FROM_URL',
}
